export type WindowSize = {
  label: string;
  value: string;
}

export const AUTO: WindowSize = { label: "Auto", value: "auto" };
export const ONE_SECOND: WindowSize = { label: "1 second", value: "1s" };
export const TEN_SECONDS: WindowSize = { label: "10 seconds", value: "10s" };
export const TWENTY_SECONDS: WindowSize = { label: "20 seconds", value: "20s" };
export const ONE_MINUTE: WindowSize = { label: "1 minute", value: "1m" };
export const FIVE_MINUTES: WindowSize = { label: "5 minutes", value: "5m" };
export const TEN_MINUTES: WindowSize = { label: "10 minutes", value: "10m" };
export const ONE_HOUR: WindowSize = { label: "1 hour", value: "1h" };
export const SIX_HOURS: WindowSize = { label: "6 hours", value: "6h" };
export const ONE_DAY: WindowSize = { label: "1 day", value: "1d" };
export const ONE_WEEK: WindowSize = { label: "1 week", value: "1w" };
export const TWO_WEEKS: WindowSize = { label: "2 weeks", value: "2w" };
export const ONE_CALENDAR_MONTH: WindowSize = { label: "1 calendar month", value: "1mo" };
export const ONE_CALENDAR_YEAR: WindowSize = { label: "1 calendar year", value: "1y" };

export const WINDOW_SIZES = [
  AUTO,
  TEN_SECONDS,
  TWENTY_SECONDS,
  ONE_MINUTE,
  FIVE_MINUTES,
  TEN_MINUTES,
  ONE_HOUR,
  SIX_HOURS,
  ONE_DAY,
  ONE_WEEK,
  TWO_WEEKS,
  ONE_CALENDAR_MONTH,
  ONE_CALENDAR_YEAR,
];

export const DEFAULT_WINDOW_SIZE = AUTO;
